export const VIDEO_API_ROUTES = {
    SESSION_TOKEN: (videoId: string, privateToken: string) => `/vod/${videoId}/token/${privateToken}/session`,
    GET_PRIVATE_THUMBNAIL: (videoId: string, privateToken: string, avh: string) => `/vod/${videoId}/token/${privateToken}/thumbnail.jpg?avh=${avh}`,
    GET_PRIVATE_VIDEO: (videoId: string, privateToken: string, avh: string) => `/vod/${videoId}/token/${privateToken}/mp4/source.mp4?avh=${avh}`,
};
